<template>
  <div>
    <section
      v-if="currentDeepRoute === 1"
    >
      <component
        :is="activeBoardConfiguration?.views.list.component"
        :key="$route.path"
        :config="activeBoardConfiguration"
        :content-type-label="contentTypeLabel"
      />
    </section>
    <section
      v-if="currentDeepRoute === 2"
    >
      <router-view />
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import GenericListing from './templates/GenericListing.vue';
import CandidateList from '@/components/layouts/CandidateList.vue';

export default {
  name: 'DynamicList',
  components: { GenericListing, CandidateList },
  props: {
    contentTypeLabel: {
      type: String,
      default: null
    }
  },
  computed: {
    currentDeepRoute () {
      return this.$route.meta.currentDeepRoute;
    },
    ...mapState([
      'activeBoardConfiguration',
      'activeWorkspace'
    ])
  },
  watch: {
    currentDeepRoute () {
      console.log('[DYNAMIC_LIST] => currentDeepRoute');
      this.setConfigurationsByLabel({ label: this.contentTypeLabel });
      if (this.$route.meta.currentDeepRoute === 1) {
        this.searchData();
      }
    },
    async contentTypeLabel () {
      console.log('[DYNAMIC_LIST] => contentTypeLabel');
      this.$store.dispatch('resetFilters');
      this.setConfigurationsByLabel({ label: this.contentTypeLabel });
      await this.parseUrlData(this.$route.query);
      if (this.$route.meta.currentDeepRoute === 1) {
        this.searchData();
      }
    },
    async activeWorkspace () {
      console.log('[DYNAMIC_LIST] => activeWorkspace');
      await this.parseUrlData(this.$route.query);
      this.searchData();
    }
  },
  async mounted () {
    console.log('[DYNAMIC_LIST] => mounted');
    this.setConfigurationsByLabel({ label: this.contentTypeLabel });
    if (this.$router.currentRoute.name !== 'offer-candidature') {
      await this.parseUrlData(this.$route.query);
    }
    if (this.$route.meta.currentDeepRoute === 1) {
      this.searchData();
    }
  },
  methods: { ...mapActions(['setConfigurationsByLabel', 'parseUrlData', 'searchData']) }
};
</script>
